import {
  buildFilterObject,
  Edit,
  EditSelectionItemProps,
  FilterProps,
  StringMap,
} from "../../../components";
import { useLanguage } from "../../../hooks";
import { INCIDENT_STATUSES, INCIDENT_TYPES } from "../support.props";
import "../support.css";

enum SupportFilterEnum {
  TYPE = "type",
  NAME = "name",
  DESCRIPTION = "description",
  STATUS = "status",
  DATE = "date",
}

interface SupportFiltersProps {
  filters: StringMap;
  setFilters: React.Dispatch<React.SetStateAction<StringMap>>;
}

const SupportFilters: React.FC<SupportFiltersProps> = ({
  filters,
  setFilters,
}) => {
  const { t } = useLanguage();

  const itemsType: EditSelectionItemProps[] = INCIDENT_TYPES.map((key) => ({
    key,
    text: t.supportScreen.table.types[key],
  }));

  const itemsStatus: EditSelectionItemProps[] = INCIDENT_STATUSES.map(
    (key) => ({ key, text: t.supportScreen.table.tbody[key] })
  );

  const handleChange = (data: FilterProps) => {
    const { key, value } = data;

    setFilters((prevFilters) => {
      return { ...prevFilters, [key]: value };
    });
  };

  const handleSelection = (id: string, data: EditSelectionItemProps) => {
    handleChange({ key: id, value: data.key });
  };

  const handleDate = (value: string) => {
    handleChange({ key: SupportFilterEnum.DATE, value });
  };

  return (
    <>
      <Edit>
        {/* TYPE */}
        <Edit.Selection
          id={SupportFilterEnum.TYPE}
          placeholder={t.supportScreen.fields.incidentType}
          items={itemsType}
          selected={buildFilterObject(
            SupportFilterEnum.TYPE,
            filters,
            itemsType
          )}
          onSelect={(data, id) => handleSelection(id, data)}
        />

        {/* NAME */}
        <Edit.Input
          id={SupportFilterEnum.NAME}
          value={filters[SupportFilterEnum.NAME]}
          placeholder={t.supportScreen.fields.name}
          onChange={(e) =>
            handleChange({ key: e.target.id, value: e.target.value })
          }
        />

        {/* STATUS */}
        <Edit.Selection
          id={SupportFilterEnum.STATUS}
          placeholder={t.supportScreen.fields.status}
          items={itemsStatus}
          selected={buildFilterObject(
            SupportFilterEnum.STATUS,
            filters,
            itemsStatus
          )}
          onSelect={(data, id) => handleSelection(id, data)}
        />

        {/* DATE */}
        <Edit.CalendarSelect
          id={SupportFilterEnum.DATE}
          value={filters[SupportFilterEnum.DATE]}
          onChange={handleDate}
        />
      </Edit>
    </>
  );
};

export default SupportFilters;
